import { memo, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import RadioButtonGroup from '../../../../components/RadioButtonGroup/RadioButtonGroup';
import { priceVariationToLaborableTime } from '../../../../utilities/functions/FormatterUtil';
import FONTS_FAMILY from '../../../../theme/FontsFamily';
import {
    Container, Header, Body, ButtonsContainer, CardButton
} from './styles/PaymentCardStyles';

function PaymentCard({ title, onClick, onCancel, variations }) {
    const [servicePrice, setServicePrice] = useState(variations?.[0]?.price);
    const [selectedVariation, setSelectedVariation] = useState(variations?.[0]);

    const variationsForCheckGroup = variations?.map((variation) => {
        return {
            label: `${variation.concept} ($${variation.price})`,
            value: variation.id,
        };
    });

    const handleRadioChange = (value) => {
        const variation = variations.find((v) => v.id == value);
        setServicePrice(variation?.price);
        setSelectedVariation(variation);
    };

    return (
        <Container>
            <Header>
                <Box
                    sx={{
                        width: '100%',
                        background: '#EEF2FF',
                        border: '1px solid #D0DBF3',
                        borderRadius: '16px',
                        py: 2.5,
                        px: 3,
                        textAlign: 'center',
                        boxShadow: 'none'
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: 'Roboto, sans-serif',
                            fontSize: '12px',
                            fontWeight: 700,
                            color: '#0B8296',
                            textTransform: 'uppercase',
                            letterSpacing: '1px',
                            mb: 0.5
                        }}
                    >
                        Costo del Servicio
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: 'Merriweather, Georgia, serif',
                            fontSize: { xs: '30px', sm: '36px' },
                            fontWeight: 800,
                            color: '#0F2350'
                        }}
                    >
                        RD$ {Number(servicePrice).toLocaleString('es-DO', { minimumFractionDigits: 2 })}
                    </Typography>
                </Box>
            </Header>

            <Body>
                {variations.length > 1 && (
                    <Box sx={{ width: '100%', textAlign: 'left', mb: 1 }}>
                        <RadioButtonGroup
                            options={variationsForCheckGroup}
                            title="Opciones de servicio"
                            helperText={null}
                            onChange={(e) => handleRadioChange(e.target.value)}
                            value={selectedVariation?.id}
                        />
                    </Box>
                )}

                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1.5,
                        bgcolor: '#FFFFFF',
                        border: '1px solid #E1E9EC',
                        borderRadius: '12px',
                        py: 1.5,
                        px: 2.5,
                        width: '100%',
                        mt: 0.5
                    }}
                >
                    <AccessTimeIcon sx={{ color: '#0B8296', fontSize: 22 }} />
                    <Box sx={{ textAlign: 'left' }}>
                        <Typography
                            sx={{
                                fontFamily: 'Roboto, sans-serif',
                                fontSize: '11px',
                                fontWeight: 700,
                                color: '#57697F',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px'
                            }}
                        >
                            Tiempo Estimado de Entrega
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: 'Merriweather, Georgia, serif',
                                fontSize: '15px',
                                fontWeight: 700,
                                color: '#0F2350'
                            }}
                        >
                            {priceVariationToLaborableTime(variations?.find((v) => v.id == selectedVariation?.id)?.delivery_time)}
                        </Typography>
                    </Box>
                </Box>
            </Body>

            <ButtonsContainer>
                <Button
                    variant="outlined"
                    onClick={onCancel}
                    sx={{
                        flex: 1,
                        height: '48px',
                        color: '#57697F',
                        borderColor: '#CFDCE0',
                        borderRadius: '12px',
                        textTransform: 'none',
                        fontFamily: FONTS_FAMILY.bold.body,
                        fontSize: '14.5px',
                        fontWeight: 700,
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            borderColor: '#0F2350',
                            color: '#0F2350',
                            backgroundColor: '#F8FAFC'
                        }
                    }}
                >
                    Cancelar
                </Button>
                <CardButton sx={{ flex: 1 }} onClick={() => onClick(selectedVariation)}>
                    Confirmar
                </CardButton>
            </ButtonsContainer>
        </Container>
    );
}

export default memo(PaymentCard);
